const TEAM_NAME_OVERRIDES = {
  // Anfitriones
  Canada: 'CAN',
  Mexico: 'MEX',
  USA: 'EE.UU.',

  // CONMEBOL
  Argentina: 'ARG',
  Brazil: 'BRA',
  Colombia: 'COL',
  Ecuador: 'ECU',
  Paraguay: 'PAR',
  Uruguay: 'URU',

  // CONCACAF
  Panama: 'PAN',
  Haiti: 'HAI',
  Curaçao: 'CUW',

  // UEFA
  Austria: 'AUT',
  Belgium: 'BEL',
  'Bosnia and Herzegovina': 'BIH',
  Croatia: 'CRO',
  Czechia: 'CZE',
  England: 'ING',
  France: 'FRA',
  Germany: 'ALE',
  Netherlands: 'NLD',
  Norway: 'NOR',
  Portugal: 'POR',
  Scotland: 'ESC',
  Spain: 'ESP',
  Sweden: 'SUE',
  Switzerland: 'SUI',
  Sqwizterland: 'SUI', // typo legacy
  Turkiye: 'TURQ',
  Türkiye: 'TURQ',

  // AFC
  Australia: 'AUS',
  Iraq: 'IRQ',
  'IR Iran': 'IRN',
  Japan: 'JPN',
  Jordan: 'JOR',
  'Korea Republic': 'COR',
  Qatar: 'QAT',
  'Saudi Arabia': 'ASAU',
  Uzbekistan: 'UZB',

  // CAF
  Algeria: 'ALG',
  'Cabo Verde': 'CPV',
  'Cape Verde': 'CPV',
  'Congo DR': 'COD',
  "Côte d'Ivoire": 'CDM',
  Egypt: 'EGI',
  Ghana: 'GHA',
  Morocco: 'MAR',
  Senegal: 'SEN',
  'South Africa': 'SA',
  Tunisia: 'TUN',

  // OFC
  'New Zealand': 'NZL',
};

/** Resolve display label for a FIFA IdCountry code; falls back to uppercase code. */
export const getTeamDisplayName = (teams, code) => {
  if (!code) {
    return '';
  }
  const key = String(code).toLowerCase();
  const name = teams?.[key];
  if (name) {
    return TEAM_NAME_OVERRIDES[name] || name;
  }
  return String(code).toUpperCase();
};
